import css from './Select.module.css'
import ArrowDownIcon from '../../../assets/icons/icon-arrow-down.svg?react'

interface SelectOption {
    value: string
    label: string
}

interface SelectProps {
    value: string
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
    options: SelectOption[]
    placeholder?: string
    disabled?: boolean
}

const Select = ({ value, onChange, options, placeholder, disabled = false }: SelectProps) => {
    return (
        <div className={css.wrapper}>
            <select
                className={`${css.select}${value === '' ? ` ${css.placeholder}` : ''}`}
                value={value}
                onChange={onChange}
                disabled={disabled}
            >
                {placeholder && (
                    <option value="" disabled>{placeholder}</option>
                )}
                {options.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
            </select>
            <span className={css.icon}>
                <ArrowDownIcon />
            </span>
        </div>
    )
}

export default Select
